module.exports = __webpack_public_path__ + "media/images/flags/4x3/ury-f53324b64139322fc0b8b37a6f7345d4.svg";